module.exports = __webpack_public_path__ + "img/research1.dd2f9687.jpg";